import _ from 'lodash'
import auth from '../auth'

export default {
    data() {
        return {
        }
    },
	computed: {
        authenticated() {
            return this.$store.state.authenticated
		},
		authID() {
			return this.$store.state.profile.uid
        },
        userData() {
            return this.$store.state.userData
        },
        profile() {
    		return this.$store.state.profile
    	},
	},
	methods: {
        signin() {
            this.$router.push({name: 'login'})
        },
        signout() {
            this.$router.push({name: 'logout'})
        },
        isAuth() {
            return new Promise((resolve, reject) => {
                if(this.authenticated) {
                    resolve(true)
                }
                else {
                    console.log('*** Error: You are not authenticated. ***');
                    reject();
                }
            })
        },
	}
}
